import React, { useState, lazy } from 'react';
import { Product } from '../types/types';
import { PlusIcon } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';
interface ProductCardProps {
  product: Product;
  onAdd: (product: Product) => void;
}
export function ProductCard({
  product,
  onAdd
}: ProductCardProps) {
  const [imgError, setImgError] = useState(false);
  const {
    t,
    formatPriceInline,
    translateProductName,
    translateProductDescription
  } = useLanguage();
  const translatedName = translateProductName(product.id, product.name);
  const translatedDescription = translateProductDescription(product.id, product.description);
  // Show "Desde" badge if product has multiple sizes
  const hasSizes = product.sizes && product.sizes.length > 1;
  return <div className="bg-surface rounded-2xl shadow-sm border border-gray-800 flex flex-col h-full overflow-hidden" data-id="element-1522">
      {product.image && !imgError && <div className="h-28 w-full bg-surface-light relative overflow-hidden" data-id="element-1523">
          <img src={product.image} alt={translatedName} loading="lazy" decoding="async" onError={() => setImgError(true)} className="w-full h-full object-cover" data-id="element-1524" />
        </div>}
      <div className="p-4 flex flex-col flex-1" data-id="element-1525">
        <div className="flex-1" data-id="element-1526">
          <div className="flex justify-between items-start mb-1.5 gap-2" data-id="element-1527">
            <h3 className="font-heading font-semibold text-white text-sm leading-tight tracking-wide" data-id="element-1528">
              {translatedName}
            </h3>
          </div>
          <div className="flex items-center gap-1.5 mb-2" data-id="element-1529">
            {hasSizes && <span className="text-[10px] text-gray-500 font-medium" data-id="element-1530">
                Desde
              </span>}
            <span className="font-semibold text-verde text-xs" data-id="element-1531">
              {formatPriceInline(product.price)}
            </span>
          </div>
          {translatedDescription && <p className="text-gray-400 text-xs leading-snug mb-3 line-clamp-2" data-id="element-1532">
              {translatedDescription}
            </p>}
        </div>

        <button onClick={() => onAdd(product)} className="mt-auto w-full bg-verde/10 text-verde font-medium py-2.5 rounded-xl flex items-center justify-center gap-1 active:bg-verde active:text-white transition-colors min-h-[44px] text-sm border border-verde/20" data-id="element-1533">
          {product.customizable || product.type === 'pizza' && hasSizes ? <>
              {product.type === 'pizza' ? 'Armá tu pizza 🍕' : t('customize')}{' '}
              <PlusIcon className="w-4 h-4" data-id="element-1534" />
            </> : <>
              {t('add')} <PlusIcon className="w-4 h-4" data-id="element-1535" />
            </>}
        </button>
      </div>
    </div>;
}
;
'>';